// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_nn-0";
export var animationContainer = "_nn-1";
export var itemPrice = "_nn-a";
export var itemizedContent = "_nn-9";
export var itemizedHeader = "_nn-7";
export var itemizedRow = "_nn-8";
export var itemizedSection = "_nn-6";
export var modalContent = "_nn-2";
export var orderName = "_nn-3";
export var refundOption = "_nn-4";
export var refundOptionsContainer = "_nn-5";
export var shippingLabel = "_nn-b";
export var totalRow = "_nn-c";